import React from 'react';
const DeleteAccount = () => {
  return (
    <div className="container mx-auto p-6" style={{ maxWidth: '600px',}}>
      <h1 className="text-3xl font-bold mb-4" style={{ textAlign:"center"}}>Delete Your Roomate Account</h1>
      <p className="mb-4" style={{ textAlign:"center"}}>
      To request the deletion of your Trimify account and associated data, please follow these steps:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <p><strong>1.Email Request:</strong> Send an email to support@roomease.co.in with the subject line "Account Deletion Request". Include your account username and email address associated with your Trimify account.</p>
        <p><strong>2.Verification:</strong> We will send a confirmation email to verify your request. Please respond to this email to confirm the deletion.</p>
        <p><strong>3.Processing: </strong> Once confirmed, we will process your request within 7 business days.</p>
        <p><strong>4.Data Deletion: </strong> </p>  
        <p><strong>Deleted Data: </strong> All personal information, viewing history, and payment information will be permanently deleted.</p>    
        <p><strong>Retained Data:</strong> Some data may be retained for legal or regulatory purposes, such as transaction records, for up to [retention period] after account deletion. For more information, please refer to our Privacy Policy.</p>    
      </ul>
    </div>
  );
};
export default DeleteAccount;